export const Videos = (() => {
	'use strict';

	let $videoPoster;

	function init() {
		$videoPoster = $(".media--video_mp4 .video__poster");
		
		if ($videoPoster) {		
			$videoPoster.each(function(i, el) {
				$(el).click(playVideo);
			});
		}
	}

	function playVideo(e){
		
		let $poster = $(this),
			$videoContainer = $poster.closest('.media--video_mp4'),
			$video = $videoContainer.find('.video'),
			loopStart = $video.attr('data-loop-start'),
			video = $video[0];

			$poster.fadeOut(200);
			
			video.play();
			
			if (loopStart > 0) {
				video.addEventListener("ended", function(){
					video.currentTime = loopStart;
					video.play();
				}, false);					
			}
	}

	return {
		init: init
	};
})();
